import { useMutation, useQueryClient } from '@tanstack/react-query';
import { addAppInstanceInlineQuery } from '../apis';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import queryKeyAppInstance from '../constants/queryKeyAppInstance';
import { addItemAppInstance } from '..';

const useAddAppInstanceInline = () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const { filter } = useSelector((s) => s.appInstance);

  const addAppInstanceInline = useMutation({
    mutationFn: addAppInstanceInlineQuery,
    onSuccess: (result) => {
      toast.success('Add App Instance successfully');
      dispatch(addItemAppInstance(result?.data));
      queryClient.invalidateQueries([
        queryKeyAppInstance.getList(JSON.stringify(filter ?? {})),
      ]);
    },
    onError: (error) => {
      const message = error?.response?.data?.message ?? 'Server error';
      toast.error(message);
      console.error('Error add app instance:', error);
    },
  });

  return addAppInstanceInline;
};

export default useAddAppInstanceInline;
